import { showMessages } from "../../components/AlertMessages/AlertMessages";
import { P232GetDataPrint } from "../../service/200/P232Service";

export const onP232GetDataPrint = (setLoading, dataReq, setData, toast) => {
    // setLoading(true);
    P232GetDataPrint(dataReq).then(
        (res) => {
            setLoading(false);
            if (res !== undefined) {
                let temp = [];
                let index = 1;
                res.forEach((element) => {
                    temp.push({
                        ...element,
                        deliverNo: dataReq.deliverNo,
                        index: index,
                    });
                    index++;
                });
                if (temp.length > 0) {
                    setData(temp[0]);
                }
            } else {
                showMessages(toast, "error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
            }
        },
        function (err) {
            if (err.response && err.response.data.status === 401) {
                alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                window.location.href = "/login";
            } else {
                showMessages(toast, "error", `เกิดข้อผิดพลาด : ${err} `, "");
            }
            setLoading(false);
        }
    );
};
